import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import LoopIcon from '@mui/icons-material/Loop';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button, Divider, TextField } from '@mui/material';
import FuelAutoComplete from '../fuel-autocomplete';
import { AlertType } from './FuelCalendarContainer';
import clientUtils from '../../utils/clientUtils';
import useAppUtils from '../../utils/appUtils';
import FuelToggleButton from '../fuel-toggle-button/fuel-toggle-button';
import { ChannelType } from '../../enums';

const slotTimeScaleList = [
  {
    id: 1,
    name: '60 Minutes',
    textValue: '00:60:00',
  },
  {
    id: 2,
    name: '30 Minutes',
    textValue: '00:30:00',
  },
  {
    id: 3,
    name: '15 Minutes',
    textValue: '00:15:00',
  },
  {
    id: 4,
    name: '10 Minutes',
    textValue: '00:10:00',
  },
  {
    id: 5,
    name: '6 Minutes',
    textValue: '00:06:00',
  },
  {
    id: 6,
    name: '5 Minutes',
    textValue: '00:05:00',
  },
];
type calendarView = 'Channel' | 'LiveProgram';
interface Iprops {
  onToolBarItemChange:(event, slotTime, type, isAdBreaksEnable) => void;
  channelFormValues?:any;
  viewType?:calendarView;
}
const CalendarToolBar = ({ onToolBarItemChange, channelFormValues = null, viewType = 'Channel' }) => {
  const [slotTime, setSlotTime] = useState(slotTimeScaleList[1]);
  const [actionType, setActionType] = useState<AlertType>('None');
  const { alert, confirm } = useAppUtils();
  const [viewAdBreaks, setViewAdBreaks] = useState(channelFormValues ? channelFormValues.getValues('viewAdBreaks') : 'None');
  const [channelType, setChannelType] = useState(channelFormValues ? channelFormValues.getValues('type') : 'None');

  const toolBarItemClick = (event) => {
    onToolBarItemChange(event, slotTime.textValue, 'event', viewAdBreaks);
  };

  const slotTimeChange = (value) => {
    setSlotTime(value);
    onToolBarItemChange(null, value.textValue, 'slotTime', viewAdBreaks);
  };

  const epgMrssFeedUrlToClipboard = () => {
    if (channelFormValues.getValues('mrssFeedEpgUrl')) {
      clientUtils.copyToClipboard(channelFormValues.getValues('mrssFeedEpgUrl'));
      alert(`EPG Feed Url copied to clipboard`);
    }
  };
  const viewAdBreaksChange = (e) => {
    setViewAdBreaks(e.target.checked);
    onToolBarItemChange(null, slotTime.textValue, 'adBreaks', e.target.checked);
  };

  return (
    <div className="overview-toolbar">
      <div
        className="toolbar-items e-toolbar"
        onClick={toolBarItemClick}
        style={{ height: '72px', width: '50%', border: '1px solid rgba(0,0,0,.12)' }}
      >
        <div className="e-toolbar-item">
          <button className="e-tbar-btn e-btn" title="New Event">
            <span className="e-icons">
              <AddIcon className="e-icons" titleAccess="New Event" id="New Event" />
            </span>
            <span className="e-tbar-btn-text">New Event</span>
          </button>
        </div>
        <div className="e-toolbar-item">
          <button className="e-tbar-btn e-btn" title="New Recurring Event">
            <span className="e-icons">
              <LoopIcon className="e-icons" titleAccess="New Recurring Event" id="New Recurring Event" />
            </span>
            <span className="e-tbar-btn-text">New Recurring Event</span>
          </button>
        </div>
        <Divider orientation="vertical" flexItem></Divider>
        <div className="e-toolbar-item">
          <button className="e-tbar-btn e-btn" title="Day">
            <span className="e-icons" title="Day">
              <CalendarTodayIcon className="e-icons" titleAccess="Day" id="Day" />
            </span>
            <span className="e-tbar-btn-text">Day</span>
          </button>
        </div>
        <div className="e-toolbar-item">
          <button className="e-tbar-btn e-btn" title="Week">
            <span className="e-icons" title="Week">
              <DateRangeIcon className="e-icons" titleAccess="Week" id="Week" />
            </span>
            <span className="e-tbar-btn-text">Week</span>
          </button>
        </div>
        <div className="e-toolbar-item">
          <button className="e-tbar-btn e-btn" title="Month">
            <span className="e-icons" title="Month">
              <CalendarMonthIcon className="e-icons" titleAccess="Month" id="Month" />
            </span>
            <span className="e-tbar-btn-text">Month</span>
          </button>
        </div>
        <Divider orientation="vertical" flexItem></Divider>
        <div className="e-toolbar-item time-scale-container">
          <FuelAutoComplete
            id="slot-time-select"
            items={slotTimeScaleList}
            itemText="name"
            itemKey="id"
            labelText="Time Scale"
            placeHolderText="Select Time Scale"
            controlWidth={250}
            multiSelect={false}
            labelPaddingTop="-5px"
            defaultValue={slotTime}
            onChange={(value) => slotTimeChange(value)}
          />
        </div>
        {channelType && channelType.id === ChannelType.Scheduled && viewType === 'Channel' && (
          <div className="e-toolbar-item view-ad-breaks-container">
            <p>View Ad Breaks</p>
            <div className="view-ad-breaks-toggle">
              <FuelToggleButton change={(e) => viewAdBreaksChange(e)} value={viewAdBreaks} />
            </div>
          </div>
        )}
      </div>
     {viewType === 'Channel' &&  <div style={{ height: '72px', width: '50%', border: '1px solid rgba(0,0,0,.12)' }}>
        <div className="form-group copy-epg-feed-section ">
          <TextField
            className="copy-epg-url-field"
            sx={{ ml: 1, mr: 1, mt: 1 }}
            placeholder="URL"
            disabled
            label="EPG MRSS Feed"
            variant="outlined"
            fullWidth
            size="small"
            value={channelFormValues.getValues('mrssFeedEpgUrl')}
          />
          <Button className="copy-url-button" variant="contained" color="success" onClick={epgMrssFeedUrlToClipboard}>
            Copy Url
          </Button>
        </div>
      </div>}
    </div>
  );
};

export default CalendarToolBar;
